import styled from "styled-components";
import "../../styles/variables.css";

export const WalletConnectedContainer = styled.div`
  width: 100%;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 16px;
  background: var(--bg-info-alert);
  border: 1px solid var(--blue-50);
  box-shadow: 0px 0px 8px rgba(56, 78, 101, 0.15);
  margin: 16px 0;

  span {
    font-size: var(--fs14);
  }
  label {
    color: var(--gray-20);
    font-size: var(--fs14);
    font-weight: 400;
  }
`;

export const AvatarContainer = styled.div`
  margin-right: 16px;
  display: flex;

  & > * {
    border-radius: 50%;
  }
`

export const AddressesContainer = styled.div`
  text-align: left;
`

export const Address = styled.div`
  font-size: var(--fs14);
  color: var(--gray-50);
  font-weight: 400;
`